import type { AxiosInstance } from "axios";
import type { JsonParticipantEntry } from "@shared/schemas/participant-import-json.schemas";
import type {
  ImportParticipantsResult,
  ClassifyParticipantsResult,
} from "@shared/schemas/event-participant.schemas";
import { EventIdPublic } from "@shared/schemas/branded-id.schemas";

export function createImportsApi(apiClient: AxiosInstance) {
  return {
    async importJson(
      eventIdPublic: EventIdPublic,
      participants: readonly JsonParticipantEntry[],
    ): Promise<ImportParticipantsResult> {
      const response = await apiClient.post<ImportParticipantsResult>(
        `/api/v1/events/${EventIdPublic.unwrap(eventIdPublic)}/participant-imports`,
        { participants },
      );
      return response.data;
    },

    async classifyJson(
      eventIdPublic: EventIdPublic,
      participants: readonly JsonParticipantEntry[],
    ): Promise<ClassifyParticipantsResult> {
      const response = await apiClient.put<ClassifyParticipantsResult>(
        `/api/v1/events/${EventIdPublic.unwrap(eventIdPublic)}/participant-imports/classify`,
        { participants },
      );
      return response.data;
    },
  };
}
